import BackgroundFocus from '../Components/BackgroundFocus/background-focus.js';

[].slice.call(document.querySelectorAll('[data-focus]:not(.js-lazybg)')).forEach(image => {
  try {
    BackgroundFocus.observe(image, JSON.parse(image.dataset.focus), true);
  } catch (e) {
    // do nothing if there is an error in the json string
  }
});
